import VehiclesErrorsFactory from '../Errors/factory.js'
import {GetModelVersionsRequest} from './GetModelVersionsRequest.js'
import {GetVehiclesInfoByPlateRequest} from './GetVehiclesInfoByPlateRequest.js'

export class VehiclesRequestsFactory {
  static getVehiclesInfoByPlateRequest = ({config, plate}) => {
    GetVehiclesInfoByPlateRequest.validate({
      config,
      plate,
      genericVehiclesErrorFactory: VehiclesErrorsFactory.genericVehiclesErrorFactory
    })

    return new GetVehiclesInfoByPlateRequest({plate})
  }

  static getModelVersionsRequestValueObjectFactory = ({
    competitorsCount,
    includeInsights,
    makeId,
    modelId,
    onlyCurrentVersions,
    pageName
  }) => {
    GetModelVersionsRequest.validate({
      makeId,
      modelId,
      genericVehiclesErrorFactory: VehiclesErrorsFactory.genericVehiclesErrorFactory
    })

    return new GetModelVersionsRequest({
      competitorsCount,
      includeInsights,
      makeId,
      modelId,
      onlyCurrentVersions,
      pageName
    })
  }
}
